$(document).ready(function () {
  const slides = document.querySelectorAll('.announcement_slider .header_announcement');
  let currentIndex = 0;
  // Hide all slides initially
  slides.forEach(slide => {
    slide.style.opacity = 0;
    slide.style.transition = 'opacity 1s';
  });
  // Show the first slide
  slides[currentIndex].style.opacity = 1;
  function showSlide() {
    // Fade out current slide
    slides[currentIndex].style.opacity = 0;
    // Move to the next slide
    currentIndex = (currentIndex + 1) % slides.length;
    // Fade in the next slide
    setTimeout(() => {
      slides[currentIndex].style.opacity = 1;
    }, 200);
  }
  // Automatically switch slides every 5 seconds
  setInterval(showSlide, 5000);

});


$(document).ready(function () {
  
  // if ($(window).width() <= 1024) {
  //   $(".has_dropdown > a ").on("click", function (e) {
  //     e.preventDefault();
  //     let $parent = $(this).parent(".has_dropdown");

  //     $parent.removeClass("show_dropdown");
  //     $parent.siblings().show();
  //     $parent.parent('ul').siblings().show();

  //     // if ($parent.hasClass("show_dropdown")) {
  //     //   $parent.removeClass("show_dropdown");
  //     //   $parent.siblings().show();
  //     //   $parent.parent('ul').siblings().show();
  //     // } else {
  //     //   $parent.removeClass("show_dropdown");
  //     //   $parent.addClass("show_dropdown");
  //     //   $parent.siblings().hide();
  //     //   $parent.parent('ul').siblings().hide(); 
  //     // }
      
  //   });  
  // }  


  //Mobile Menu Drop Down Toggle
  if ($(window).width() <= 1024) {
    $(".has_dropdown > a ").on("click", function (e) {
      $(this).parent().siblings().find("a").removeClass("active");
      $(this).parent().siblings().find(".header_nav_sublist").slideUp(350);
      $(this).parent().find(".header_nav_sublist").slideToggle(350);
      $(this).toggleClass("active");
      e.preventDefault();
    });
  }
  

  if ($(window).width() >= 1025) {
    $(".header_menu").mouseenter(function () {
      $("header .header_overlay").show();
    })
    $(".header_menu").mouseleave(function () {
      $("header .header_overlay").hide();
    });
  } 


  var nav = ["show_menu", "show_cart", "show_input"];
  $(".header_overlay, .header_cart_sidebar_close").click(function () {
    $("body").removeClass(nav.join(" "));
    $("body").removeClass("scroll ");
  });  
  $(".header_search_text").click(function () {
    $("body").addClass("show_input");
    $(".header_search").find("input").focus();
  });  
  $(".click_event").click(function (e) {
    let id = e.target.id;  
    // If already has this class, remove it (toggle off)
    if ($("body").hasClass(id)) {
      $("body").removeClass("scroll " + id);
    } else {
      // Otherwise remove other nav-related classes and add new one
      $("body").removeClass(nav.join(" "));
      $("body").addClass("scroll " + id);
    }
  });
  

  $(".menu_button_toggle").click(function () {
    // $('body').toggleClass("scroll");
    $('body').toggleClass("scroll show_menu");
  });
  

  // cart quantity update
  $(".header_cart_item_footer button, .item_qty_select button").click(function () {
    if ($(this).data("type") == "inc") {
      $(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) + 1);
    } else {
      if ($(this).parent().find("input").val() == 1) {
        return;
      }
      $(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) - 1);
    }
  });

  $(".close_announcement").click(function () {
    $(".header_announcements").hide();
    $("body").addClass("spacing");
  });
  
});


// search input onchange
function searchOnchange(e) {
  if (e.value.length > 0) {
    $(".search_result_default_list").hide()
    $(".search_result_list").show()
  } else {
    $(".search_result_default_list").show()
    $(".search_result_list").hide()
  }
}
// cart quantity input onchange
function cartOnchange(e) {
  if (e.value == 0) {
    e.value = 1
  }
}


// Collection tabs  
$(document).ready(function () {
  $('.tabs_container').each(function () {
      var $this = $(this);
      
      $this.find('.collection_tabs li').click(function () {
          var tab_id = $(this).attr('data-tab');
          
          $this.find('.collection_tabs li').removeClass('active');
          $this.find('.tab_content').removeClass('active');
          
          $(this).addClass('active');
          $this.find("#" + tab_id).addClass('active');
      });
  });
});


//Instafeed slider
$(document).ready(function () {
 var swiper2 = new Swiper(".instafeed_slider", {
    slidesPerView: 4.25,
    spaceBetween: 20,
    loop: true,
    breakpointsInverse: true,
    navigation: {
      nextEl: ".feed-button-next",
      prevEl: ".feed-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
      clickable: true,
    },
    breakpoints: {
      320: {
        centeredSlides: true,
        slidesPerView: 1.15,
        spaceBetween: 8,
      },
      480: {
        centeredSlides: true,
        slidesPerView: 1.50,
        spaceBetween: 12,
      },
      768: {
        centeredSlides: false,
        slidesPerView: 2.25,
      },
      1024: {
        slidesPerView: 3.25,
      },
    },
  });
});


// Logo slider
$(document).ready(function () {
  var swiper3 = new Swiper(".logo_slider", {
    loop:	false,
    scrollbar: false,
    pagination: false,
    slidesPerView: 3,
    breakpointsInverse: true,
    spaceBetween: 20,
    breakpoints: {
      425: {
        slidesPerView: 3,
        spaceBetween: 8
      },
      769: {
        slidesPerView: 4,
        spaceBetween: 32
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 32
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: 32
      }
   }
});

  
  var waitForJQuery = setInterval(function () {
      if (typeof $ != 'undefined') {
        $(document).ready(function () {
          $('.logo_wrapper').click(function () {
            $('.logo_wrapper').removeClass('active');
            $(this).addClass('active');
            $('.slider_description').css('opacity', 0).delay(900);
            $('.slider_description').html($(this).find('.slide_container').html()).css('opacity', 1);
          });
        });
        clearInterval(waitForJQuery);
      }
    }, 10);
    setInterval(function () {
      $('.logo_wrapper.active').parent().next().find('.logo_wrapper').click();
    }, 5000);
});


$(document).ready(function () {
  $(".tabs_description").each(function (event) {
    
      let container = $(this);
      container.find(".tab_button").on("click", function (e) {
        e.stopPropagation();
          let target = $(this).data("target");
          container.find(".tab_block").removeClass("active");
          container.find(`.tab_block[data-handle="${target}"]`).addClass("active");
          //container.find('.tab_button').removeClass("active");
        //   $(this).addClass("active");
        // $(this).addClass("active");
        //   console.log("Clicked Me!");
      });
  });
  
    $(".openModal").click(function () {
      var modalTarget = $(this).data("target");
      $(modalTarget).fadeIn();
      console.log("Opening modal for product:", modalTarget);
    });

    // Close Modal when clicking on X button
    $(".close").click(function () {
      $(this).closest(".modal").fadeOut();
    });

    // Close Modal when clicking outside the content
    $(window).click(function (e) {
      if ($(e.target).hasClass("modal")) {
          $(e.target).fadeOut();
      }
    });

});

// Accordions
$(document).ready(function () {
  $(".accordion-item").click(function () {
      // Toggle content inside the clicked .accordion-item
      $(this).find(".accordion-content").slideToggle();
      $(this).toggleClass("active");
  });
});


// Footer links dropdown
if ($(window).width() <= 1024) {
  // $('.footer_dropdown').hide();
  // $(".common_click").on("click", function () {
  //   if ($(this).hasClass("active")) {
  //     $(this).removeClass("active");
  //     $(this).siblings(".footer_dropdown").slideUp(500);
  //   } else {
  //     $(".common_click").removeClass("active");
  //     $(this).addClass("active");
  //     $(".footer_dropdown").slideUp(500);
  //     $(this).siblings(".footer_dropdown").slideDown(500);
  //   }
  // });
  
  // $(".common_click").on("click", function () {
  //   $(this).toggleClass("active");
  //   $(this).siblings(".footer_dropdown").slideToggle(500);
  // });
  
}
